import { DeviationData } from "./DeviationData";
import { DeviationStatus } from "./DeviationStatus";

export class DeviationStatistics {
  deviation: DeviationData;
  responseTime: number | undefined;
  repairTime: number | undefined;

  constructor(deviationData: DeviationData) {
    if (!deviationData?.updates?.loaded) {
      deviationData.updates.load(() => {
        this.responseTime = this.computeResponseTime();
        this.repairTime = this.computeRepairTime();
      });
    }
    this.deviation = deviationData;
    this.responseTime = this.computeResponseTime();
    this.repairTime = this.computeRepairTime();
  }

  computeResponseTime(): number | undefined {
    const response = this.deviation.updates.documents
      .filter((update) => update.date)
      .sort((a, b) => (a.date?.getTime() ?? 0) - (b.date?.getTime() ?? 0))
      .find((update) => update.status !== undefined);
    const responseTime =
      response?.date && this.deviation.reportDate?.getTime() ? (response.date.getTime() - this.deviation.reportDate?.getTime()) / 60000 : undefined;

    return responseTime && responseTime > 0 ? Math.round(responseTime) : undefined;
  }

  computeRepairTime(): number | undefined {
    const repair = this.deviation.updates.documents
      .filter((update) => update.date)
      .sort((a, b) => (a.date?.getTime() ?? 0) - (b.date?.getTime() ?? 0))
      .find((update) => update.status === DeviationStatus.SOLVED);
    const repairTime =
      repair?.date && this.deviation.reportDate?.getTime() ? (repair.date?.getTime() - this.deviation.reportDate?.getTime()) / 60000 : undefined;
    return repairTime && repairTime > 0 ? Math.round(repairTime) : undefined;
  }

  getResponseTime(): number | undefined {
    return this.responseTime;
  }

  getRepairTime(): number | undefined {
    return this.repairTime;
  }
}
